import { Content } from "antd/es/layout/layout";
import { Layout, Typography } from "antd";
import { Outlet } from "react-router";
import CategoryNav from "../../../components/common/categoryNav";
import { Link } from "react-router-dom";

const CategoryHome = () => {
  return (
    <div>
      <Layout className="">
        <div className="flex items-center ml-2 mt-2">
          <Link to={""} className="flex items-center">
            <span className="text-lg font-medium text-black ml-1">
              Categories
            </span>
          </Link>
        </div>
        <div className="flex items-center ml-2">
          <CategoryNav />
        </div>
        <Layout>
          <Content className="w-full overflow-auto over">
            <div className="">
              <Outlet />
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
export default CategoryHome;
